var map = {
	"./TaskMan.png": "43fd",
	"./Tiktok.png": "cd3c",
	"./WeChat.png": "1320",
	"./about.png": "d33d",
	"./aps.png": "444b",
	"./client.png": "ce8b",
	"./del.png": "f6c4",
	"./edit.png": "a7fb",
	"./home.png": "2875",
	"./homep1.png": "85c9",
	"./homep2.png": "6eef",
	"./homep3.png": "e859",
	"./homep4.png": "452b",
	"./homep5.png": "f409",
	"./icon_help.png": "76af",
	"./lang.png": "5062",
	"./logo.png": "9b52",
	"./logo2.png": "037a",
	"./logo_en.png": "15bf",
	"./management.png": "9cf6",
	"./mes.png": "e823",
	"./soc.png": "b176",
	"./tos.png": "2525",
	"./user.png": "d73d",
	"./users.png": "a699",
	"./wms.png": "6da9",
	"./xos.png": "78e3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "842c";